// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Bk46","name":"styles_name__3_Mt-","phone":"styles_phone__BDSBN"};